import React from 'react';
import Icon from '../Icons/Icon';
import ProductListItem from './ProductsListItem'
import Loader from 'react-loader';
import SearchField from './SearchField';

import {DropdownButton} from 'react-bootstrap';
import {MenuItem} from 'react-bootstrap';

//import CategoryArea from './CategoryArea';
import CategoryDropdown from './CategoryDropdown';





const locationOrigin = window.location.protocol + "//" + window.location.hostname + window.location.port + window.location.pathname;
export default class ProductGrid extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			resources: props.resources,
			gridClass: 'categories-filters clearfix product-grid',
			itemType: 'grid'
		}

		this.expandCategories = this.expandCategories.bind(this);
	}

	expandCategories(categories, depth) {
		depth = depth || 0;
		if (!categories || categories.length === 0) return [];
		var expandedCategories = [];
		var categoriesCopy = categories.slice();
		for(var i in categoriesCopy) {
			var cat = categoriesCopy[i];
			cat.depth = depth;
			//var subcategories = this.expandCategories(cat.items, depth + 1);

			if(expandedCategories.find(x => x.code == cat.code)=== undefined)
				expandedCategories = expandedCategories.concat(cat);

			if (cat.items.length > 0)
				this.expandCategories(cat.items, depth + 1);
		}
		return expandedCategories;
	}

	changeGridClass(shape) {
		let newClass = '';
		switch (shape) {
			case 'list':
				newClass = 'categories-filters clearfix product-grid-list'
				break;
			case 'grid':
				newClass = 'categories-filters clearfix product-grid'
				break;
			default:
				newClass = 'categories-filters clearfix product-grid'
		}
		this.setState({
			gridClass: newClass,
			itemType: shape
		})
	}

	createLabels(label, i){
		if(label !== ''){
			return (
				<li key={i} className="tag label label-info" role="treeitem">
					{label}
					<a href="javascript:void(0);" role="button" data-role="remove" onClick={this.props.deleteSearchTerm.bind(this, label)} title="Delete from the Search Criteria">x</a>
				</li>
			)
		}

	}

	createProducts(product, i){
		return <ProductListItem key={product.offerCode} Product={product} itemType={this.state.itemType} resources={this.state.resources} SearchTerm={this.props.SearchTerms}  AddToCart={this.props.AddToCart.bind(this)} />
		}

	SearchCategories(data) {
	    this.props.SearchCategories(data);
	}


	render(){
	   //console.log('-----------------');
	   //console.log(this.props.CategoryList);
		let gridIconData = {
			Fill: '#666666',
			name: 'Grid',
			Size: 26
		}

		let listIconData = {
			Fill: '#666666',
			name: 'List',
			Size: 26
		}
		let loader = this.props.isLoading ? <span id="infiniteLoader"></span> : '';
		let showSearchTerms = this.props.SearchTerms.length > 0 ? {display: 'block'} : {display: 'none'}
		let showNoResults = !this.props.loaded || this.props.hasResults && this.props.ProductList.length > 0 ? null : <div className="no-products-message">{this.state.resources["PWS.Products.NoResultsMessage"]}</div>;
		return(
			<div id="products-area" className="clearfix" role="main">
				<div className="searchTags" style={showSearchTerms}>
					<div id="tags-wrapper" className="clearfix">
						<div style={{float:'left', paddingTop: 6}}>{this.state.resources["PWS.ProductSearch.SearchCriteriaLabel"] + ": "} &nbsp;&nbsp; </div>
						<div style={{float:'left'}}>
							<ul className="bootstrap-tagsinput" role="tree" aria-live="polite">
								{this.props.SearchTerms.map(this.createLabels.bind(this))}
							</ul>
						</div>
					</div>
				</div>
				<div className="product-grid-options-filters clearfix">
					<div className="product-grid-options-wrapper clearfix">
						<a role="button" href="javascript:void(0);" id="grid-icon" className="inline-icon grid grey" onClick={this.changeGridClass.bind(this, 'grid')}>
							<Icon iconData={gridIconData} inline={true} />
						</a>
						<a role="button" href="javascript:void(0);" id="list-icon" className="inline-icon list grey" onClick={this.changeGridClass.bind(this, 'list')}>
							<Icon iconData={listIconData} inline={true} />
						</a>

						<CategoryDropdown
							CategoryList={this.expandCategories(this.props.CategoryList)}
							resources={this.state.resources}
							SearchCategories={this.SearchCategories.bind(this)}
							ActiveCategories={this.props.ActiveCategories}
							breadcrumbsList={this.props.breadcrumbsList}
							currentCategoryCode={this.props.currentCategoryCode}
						/>
						<a onClick={this.props.ResetCategories.bind(this)}>{this.state.resources["PWS.ProductSearch.ClearCategorySelection"]}</a>
						<SearchField resources={this.props.resources} />
					</div>
				</div>
						{showNoResults}
						{/*<ul id="product-grid-list" className={this.state.gridClass} role="list" aria-live="polite">
						{this.props.ProductList.map(this.createProducts.bind(this))}
					</ul>*/}

					<ul className="products">
						{this.props.ProductList.map(this.createProducts.bind(this))}

                     </ul>
			</div>
		)
                            }
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/ProductBrowse/ProductGrid.js